import React, { useState, useLayoutEffect } from "react";
import { HashRouter as Router, Route, Switch, useLocation } from "react-router-dom";

import { NavigationProvider } from "./nc";

import Layout from "./layout";
import Welcome from "./welcome";
import AuthSignIn from "./auth/signin";
import AuthVerify from "./auth/verify";
import Home from "./home";
import Profile from "./profile";
import MyOrders from "./my-orders";
import OrderDetails from "./order-details";
import Search from "./search";
import ReturnPolicy from "./return-policy";
import AboutUs from "./about-us";
import SubCategory from "./sub-category";
import Products from "./products";
import Cart from "./cart";
import Product from "./product";
import ProductDesc from "./product-desc";
import ProductSpec from "./product-spec";
import ProductGallery from "./product-gallery";
import PreInvoice from "./preinvoice";
import SelectedProducts from "./selected-products";
import PreInvoices from "./preinvoices";
import PreInvoice2 from "./preinvoice2";
import Brands from "./brands";
import Brand from "./brand";
import BrandFile from "./brand-file";
import BrandFileFullScreen from "./brand-file/full-screen";
import Checkout from "./checkout";
import AddressForm from "./checkout/address-form";

import BottomMenu from "./bottom-menu";

import "./app.scss";

function AnimatedRoutes() {
    const location = useLocation();
    const [searchText, setSearchText] = useState("");

    return (
        <Switch location={location}>
            <Route path="/welcome" component={Welcome} />
            <Route path="/signin" component={AuthSignIn} />
            <Route path="/verify/:mobile" component={AuthVerify} />

            <Route exact path="/">
                <Layout title="تامین 360" showBottomMenu={true} showBasketIcon={true} showMenuIcon={true} isBottomMenuPage={true}>
                    <Home searchText={searchText} />
                </Layout>
            </Route>

            <Route path="/profile">
                <Layout title="پروفایل" showBackIcon={true}>
                    <Profile />
                </Layout>
            </Route>

            <Route path="/my-orders">
                <Layout title="سفارش ها" showBackIcon={true} showBottomMenu={true} isBottomMenuPage={true}>
                    <MyOrders />
                </Layout>
            </Route>

            <Route path="/order/:id">
                <Layout title="جزئیات سفارش" showBackIcon={true}>
                    <OrderDetails />
                </Layout>
            </Route>

            <Route path="/search">
                <Layout showBackIcon={true} showBottomMenu={true} showBasketIcon={true} searchText={searchText} onSearchTextChange={setSearchText} isBottomMenuPage={true}>
                    <Search searchText={searchText} />
                </Layout>
            </Route>

            <Route path="/return-policy">
                <Layout title="مرجوع کالا" showBackIcon={true}>
                    <ReturnPolicy />
                </Layout>
            </Route>

            <Route path="/about-us">
                <Layout title="درباره ما" showBackIcon={true}>
                    <AboutUs />
                </Layout>
            </Route>

            <Route path="/category/:id">
                <Layout title="" showBackIcon={true} showBasketIcon={true} showBottomMenu={true}>
                    <SubCategory />
                </Layout>
            </Route>

            <Route path="/products/:categoryId">
                <Layout title="" showBackIcon={true} showBasketIcon={true} showBottomMenu={true}>
                    <Products />
                </Layout>
            </Route>

            <Route path="/cart">
                <Layout title="سبد خرید" showBackIcon={true}>
                    <Cart />
                </Layout>
            </Route>

            <Route path="/product/:id/:categoryId">
                <Layout title="" showBackIcon={true} showBasketIcon={true}>
                    <Product />
                </Layout>
            </Route>

            <Route path="/product-desc/:id/:categoryId">
                <Layout title="توضیحات" showBackIcon={true}>
                    <ProductDesc />
                </Layout>
            </Route>

            <Route path="/product-spec/:id">
                <Layout title="مشخصات" showBackIcon={true}>
                    <ProductSpec />
                </Layout>
            </Route>

            <Route path="/product-gallery/:id/:categoryId/:slickIndex/:isVideoFile">
                <Layout title="" hideHeader={true}>
                    <ProductGallery />
                </Layout>
            </Route>

            <Route path="/invoice/:categoryId">
                <Layout title="پیش فاکتور" showBackIcon={true} showPaperIcon={true}>
                    <PreInvoice />
                </Layout>
            </Route>

            <Route path="/selected-products">
                <Layout title="لیست کالاهای انتخابی" showBackIcon={true}>
                    <SelectedProducts />
                </Layout>
            </Route>

            <Route path="/invoices">
                <Layout title="پیش فاکتورها" showBackIcon={true}>
                    <PreInvoices />
                </Layout>
            </Route>

            <Route path="/preinvoice2/:brandId">
                <Layout title="پیش فاکتور" showBackIcon={true}>
                    <PreInvoice2 />
                </Layout>
            </Route>

            <Route path="/brands/:categoryId">
                <Layout title="شرکت های همراه ما" showBackIcon={true} showBasketIcon={true} showBottomMenu={true}>
                    <Brands />
                </Layout>
            </Route>

            <Route path="/brand/:id/:categoryId">
                <Layout title="" showBackIcon={true} showBasketIcon={true} showInfoIcon={true}>
                    <Brand />
                </Layout>
            </Route>

            <Route path="/brand-file/:brandId">
                <Layout title="" showBackIcon={true}>
                    <BrandFile />
                </Layout>
            </Route>

            <Route path="/brand-file-fs/:brandId/:brandFileId">
                <Layout title="" showBackIcon={true}>
                    <BrandFileFullScreen />
                </Layout>
            </Route>

            <Route path="/checkout">
                <Layout title="انتخاب آدرس" showBackIcon={true}>
                    <Checkout />
                </Layout>
            </Route>

            <Route path="/address/:id?">
                <Layout title="" showBackIcon={true}>
                    <AddressForm />
                </Layout>
            </Route>
        </Switch>
    );
}

export default function App() {
    return (
        <Router>
            <NavigationProvider>
                <AnimatedRoutes />
            </NavigationProvider>
        </Router>
    );
}
